/*
 *
 * CollaboratorsSummary constants
 *
 */
export const GET_COLLABORATORS_SUMMARY_WATCHER =
  "app/CollaboratorsSummary/GET_COLLABORATORS_SUMMARY_WATCHER"
export const GET_COLLABORATORS_SUMMARY_SUCCESS =
  "app/CollaboratorsSummary/GET_COLLABORATORS_SUMMARY_SUCCESS"
export const GET_COLLABORATORS_SUMMARY_FAILED =
  "app/CollaboratorsSummary/GET_COLLABORATORS_SUMMARY_FAILED"


export const GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER = "app/CollaboratorsSummary/GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER"
export const GET_DIVISIONS_ASSIGNMENT_SUMMARY_SUCCESS = "app/CollaboratorsSummary/GET_DIVISIONS_ASSIGNMENT_SUMMARY_SUCCESS"
export const GET_DIVISIONS_ASSIGNMENT_SUMMARY_FAILED = "app/CollaboratorsSummary/GET_DIVISIONS_ASSIGNMENT_SUMMARY_FAILED"

export const UPLOAD_TEMPLATE_COLLABORATORS_WATCHER =
  "app/CollaboratorsSummary/UPLOAD_TEMPLATE_COLLABORATORS_WATCHER"
export const UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS =
  "app/CollaboratorsSummary/UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS"
export const UPLOAD_TEMPLATE_COLLABORATORS_FAILED =
  "app/CollaboratorsSummary/UPLOAD_TEMPLATE_COLLABORATORS_FAILED"

export const UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER = "app/CollaboratorsSummary/UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER"
export const UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS = "app/CollaboratorsSummary/UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS"
export const UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED = "app/CollaboratorsSummary/UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED"

export const UPLOAD_TEMPLATE_TEAMS_WATCHER =
"app/CollaboratorsImport/UPLOAD_TEMPLATE_TEAMS_WATCHER"
export const UPLOAD_TEMPLATE_TEAMS_SUCCESS =
"app/CollaboratorsImport/UPLOAD_TEMPLATE_TEAMS_SUCCESS"
export const UPLOAD_TEMPLATE_TEAMS_FAILED =
"app/CollaboratorsImport/UPLOAD_TEMPLATE_TEAMS_FAILED"

export const SAVE_EXCEL_COLLABORATORS_WATCHER =
  "app/CollaboratorsSummary/SAVE_EXCEL_COLLABORATORS_WATCHER"
export const SAVE_EXCEL_COLLABORATORS_SUCCESS =
  "app/CollaboratorsSummary/SAVE_EXCEL_COLLABORATORS_SUCCESS"
export const SAVE_EXCEL_COLLABORATORS_FAILED =
  "app/CollaboratorsSummary/SAVE_EXCEL_COLLABORATORS_FAILED"
export const SAVE_EXCEL_COLLABORATORS_PROGRESS =
  "app/CollaboratorsSummary/SAVE_EXCEL_COLLABORATORS_PROGRESS"


export const SAVE_EXCEL_DIVISIONS_ASSIGNMENT_WATCHER = "app/CollaboratorsSummary/SAVE_EXCEL_DIVISIONS_ASSGINMENT_WATCHER"
export const SAVE_EXCEL_DIVISIONS_ASSIGNMENT_SUCCESS = "app/CollaboratorsSummary/SAVE_EXCEL_DIVISIONS_ASSGINMENT_SUCCESS"
export const SAVE_EXCEL_DIVISIONS_ASSIGNMENT_FAILED = "app/CollaboratorsSummary/SAVE_EXCEL_DIVISIONS_ASSGINMENT_FAILED"
export const SAVE_EXCEL_DIVISIONS_ASSIGNMENT_PROGRESS = "app/CollaboratorsSummary/SAVE_EXCEL_DIVISIONS_ASSGINMENT_PROGRESS"

export const GET_CEASED_SUMMARY_WATCHER =
  "app/CollaboratorsSummary/GET_CEASED_SUMMARY_WATCHER"
export const GET_CEASED_SUMMARY_SUCCESS =
  "app/CollaboratorsSummary/GET_CEASED_SUMMARY_SUCCESS"
export const GET_CEASED_SUMMARY_FAILED =
  "app/CollaboratorsSummary/GET_CEASED_SUMMARY_FAILED"

export const GET_TEAMS_SUMMARY_WATCHER =
  "app/CollaboratorsSummary/GET_TEAMS_SUMMARY_WATCHER"
export const GET_TEAMS_SUMMARY_SUCCESS =
  "app/CollaboratorsSummary/GET_TEAMS_SUMMARY_SUCCESS"
export const GET_TEAMS_SUMMARY_FAILED =
  "app/CollaboratorsSummary/GET_TEAMS_SUMMARY_FAILED"

export const UPLOAD_TEMPLATE_CEASED_WATCHER =
  "app/CollaboratorsSummary/UPLOAD_TEMPLATE_CEASED_WATCHER"
export const UPLOAD_TEMPLATE_CEASED_SUCCESS =
  "app/CollaboratorsSummary/UPLOAD_TEMPLATE_CEASED_SUCCESS"
export const UPLOAD_TEMPLATE_CEASED_FAILED =
  "app/CollaboratorsSummary/UPLOAD_TEMPLATE_CEASED_FAILED"

export const SAVE_EXCEL_CEASED_WATCHER =
  "app/CollaboratorsSummary/SAVE_EXCEL_CEASED_WATCHER"
export const SAVE_EXCEL_CEASED_SUCCESS =
  "app/CollaboratorsSummary/SAVE_EXCEL_CEASED_SUCCESS"
export const SAVE_EXCEL_CEASED_FAILED =
  "app/CollaboratorsSummary/SAVE_EXCEL_CEASED_FAILED"
export const SAVE_EXCEL_CEASED_PROGRESS =
  "app/CollaboratorsSummary/SAVE_EXCEL_CEASED_PROGRESS"

export const SAVE_EXCEL_TEAMS_WATCHER =
  "app/CollaboratorsSummary/SAVE_EXCEL_TEAMS_WATCHER"
export const SAVE_EXCEL_TEAMS_SUCCESS =
  "app/CollaboratorsSummary/SAVE_EXCEL_TEAMS_SUCCESS"
export const SAVE_EXCEL_TEAMS_FAILED =
  "app/CollaboratorsSummary/SAVE_EXCEL_TEAMS_FAILED"
export const SAVE_EXCEL_TEAMS_PROGRESS =
  "app/CollaboratorsSummary/SAVE_EXCEL_TEAMS_PROGRESS"
